import http from "@/plugins/Axios";

export default {
  actions: {
    async getAttributes(_, query) {
      try {
        let {
          data: { data, total },
        } = await http.get("attributes/list", {
          params: {
            page: query && query.page,
            limit: query && query.limit,
            name: query && query.name,
          },
        });
        data = data.map((item) => {
          item.show = (query && query.show) || false;
          item.search = "";
          return item;
        });
        return {
          data,
          lastPage: query ? Math.ceil(total / query.limit) : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
